import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  // {
  //   path: '/',
  //   redirect: '/memberRegister'
  // },
  {
    path: "/memberRegister",
    component: () => import("../views/memberRegister.vue"),
  },
  {
    path: "/checkout",
    component: () => import("../views/checkout.vue"),
  },
  {
    path: "/checkoutV2",
    component: () => import("../views/checkoutV2.vue"),
  },
  {
    path: "/checkoutV2Two",
    component: () => import("../views/checkoutV2Two.vue"),
  },
  // 新版一类收银台
  {
    path: "/checkoutV3",
    component: () => import("../views/checkoutV3.vue"),
  },
  {
    path: "/checkoutV4",
    component: () => import("../views/checkoutV4.vue"),
  },
  {
    path: "/checkoutV5",
    component: () => import("../views/checkoutV5.vue"),
  },
  {
    path: "/checkoutV6",
    component: () => import("../views/checkoutV6.vue"),
  },
  {
    path: "/checkoutV7",
    component: () => import("../views/checkoutV7.vue"),
  },
  {
    path: "/checkoutV8",
    component: () => import("../views/checkoutV8.vue"),
  },
  {
    path: "/checkoutV9",
    component: () => import("../views/checkoutV9.vue"),
  },
  {
    path: "/paymentSon",
    component: () => import("../views/paymentSon.vue"),
  },

  {
    path: "/register",
    component: () => import("../views/register.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
// 全局前置守卫
// router.beforeEach((to, from, next) => {
//   if (!to.query.sourceChannel) {
//     const queryParams = { ...to.query, sourceChannel: 'h006' };
//     next({ path: to.path, query: queryParams });
//   } else {
//     next();
//   }
// });

export default router;
